import { render } from "./RecuperoUsciti.vue?vue&type=template&id=5e3ed113&scoped=true"
import script from "./RecuperoUsciti.vue?vue&type=script&lang=js"
export * from "./RecuperoUsciti.vue?vue&type=script&lang=js"

import "./RecuperoUsciti.vue?vue&type=style&index=0&id=5e3ed113&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ma-dg\\Desktop\\wa\\ask_wizard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e3ed113"]])

export default __exports__